import { Injectable } from '@angular/core';

interface Objcd {
  corpcd: string;
  officecd: string;
  blockcd: string;
  subcd: string;
  unitcd: string;
}

@Injectable({
  providedIn: 'root',
})
export class UnitService {
  getObjcd({ corpcd, officecd, blockcd, subcd, unitcd }: Objcd) {
    return `${corpcd}${officecd}${blockcd}${subcd}${unitcd}`;
  }
}
